<template>
  <!-- 红包管理-口令红包-口令详情 -->
  <div class="category">
    <el-row :gutter="10">
      <el-col :span="2">
        <el-input v-model="query.id" placeholder="请输入用户id"></el-input>
      </el-col>
      <el-col :span="2">
        <el-input
          v-model="query.password_val"
          placeholder="请输入口令"
        ></el-input>
      </el-col>
      <el-col :span="1">
        <el-button class="pull-right" type="primary" @click="handleSearch"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="2">
        <el-button type="primary" @click="handleExport">导出</el-button>
      </el-col>
    </el-row>
    <div>
      <el-table v-loading="loading" :data="dataList">
        <el-table-column prop="price" label="金额"></el-table-column>
        <el-table-column prop="user_id" label="用户uid"></el-table-column>
        <el-table-column prop="updated_at" label="领取时间"></el-table-column>
        <el-table-column prop="password_val" label="口令"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="{ row }">
            <el-tag type="info" v-if="row.status === 0">未领取</el-tag>
            <el-tag type="success" v-if="row.status === 1">已领取</el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import http,{ api, server, getData } from '@/http'
import saveFile from '@/utils/saveFile'


export default {
    
  props: {
    id: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      redPacket: undefined,
      dataList: undefined,
      dataMeta: {},
      loading: false,
      page: 1,
      visible: false,
      buttonLoading: false,
      isEdit: false,
      query: {
        page: 1,
        id: undefined,
        password_val: undefined
      }
    }
  },

  methods: {
    handleExport() {
      //导出
      window.open(`${server}password_val_export/${this.$router.currentRoute.params.id}`)
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    getData() {
      this.loading = true
      getData(`password_packets/${this.$router.currentRoute.params.id}`, { page: this.query.page, id: this.query.id, password_val: this.query.password_val })
        .then(res => {
          this.dataList = res.data
          this.dataMeta = {
            current_page: res.current_page,
            per_page: res.per_page,
            total: res.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
    handleTypeChange() {
      this.query.page = 1
      this.getTableData()
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style>
</style>
